query ApprovalTestResult($id: UUID!) {
  approvalTestResult(id: $id) {
    id
    _rowTimestamp
    _fullComment
    comment
    _isCustomTest
    isGlobalTest
    _isUpdatable
    _isDeletable
    approvalTestGroupId
    approvalTestItemId
    approvalGroupName
    businessUnitId
    businessUnit {
      name
    }
    departmentId
    department {
      name
    }
    totalAmount
    currencyId
    currency {
      isoCode
    }
    companyPhaseTypeId
    approvalPhase {
      phaseName
    }
    requesterUserProfileId
    activeProfile {
      name
    }
    userGroupId
    userGroup {
      name
    }
    workgroupId
    workgroup {
      name
    }
    transactionHintId
    approverTransactionType {
      approvalTransactionType
    }
    purchaseOrderTypeId
    purchaseOrderType {
      purchaseOrderType
    }
    tagId
    tag {
      name
    }
    elapsedDays
    approvalLevelValueId
    approvalLevelValue {
      name
    }
    userRankId
    userRankType {
      userRank
    }
    rowSecurityId
    secureRowLevel {
      name
    }
    additionalBusinessUnitId
    additionalBusinessUnit {
      name
      approvalTestItems {
        edges {
          node {
            id
          }
        }
      }
    }
    additionalDepartmentId
    additionalDepartment {
      name
    }
    additionalAmount
  }
}
